import { Component, EventEmitter, ViewChild, Input } from '@angular/core';
import * as globals from '../globals';
import * as Materialize from 'angular2-materialize/dist/index';
import { Observable } from 'rxjs/Rx';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { AuthHttp, AuthConfig } from 'angular2-jwt';
import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';

import { UploadModelService } from './uploadmodel.service';
import { SharedService } from '../shared/shared.service';
import { UtilsService } from '../shared/utils.service';
import { UploadService } from '../shared/upload.service';
import { ProjectDataService } from '../shared/dataservice.service';
import { DropzoneWorkspaceComponent } from '../dropzone/dropzone-workspace.component';
import { DropzoneAttachComponent } from '../dropzone/dropzone-attach.component';

@Component({
    selector: 'upload-model',
    templateUrl: './uploadmodel.component.html',
    styleUrls: ['./uploadmodel.component.css'],
    providers: [UploadModelService]
  })
  export class UploadModelComponent {

    modalworkspaceUploadAction = new EventEmitter<string | MaterializeAction>();

     @ViewChild(DropzoneWorkspaceComponent) _dropzoneWorkspace: DropzoneWorkspaceComponent;
     @ViewChild(DropzoneAttachComponent) _dropzoneattach: DropzoneAttachComponent;

    @Input() _service: any;
    @Input() _projectDataService: any;
    tenanturl: string = '';
    tenantid: string = '';
    planid: string = '';

    filesToUpload: Array<File>;
    uploadingModel: boolean = false;
    progressbarActive: boolean = false;
    errorMessage: string;
    uploadCurrentValue: number;
    processingtry: number = 0;
    isProcessingCount: number = 0;
    disableUploadButton: boolean = true;

    constructor(private http: Http, public authHttp: AuthHttp, private utilsService: UtilsService,
      private service: SharedService, private uploadService: UploadService, private uploadModelService: UploadModelService, private projectDataService: ProjectDataService) {
    }

    ngOnDestroy() {
      this.modalworkspaceUploadAction.emit({ action: 'modal', params: ['close'] });
    }

  workspaceUpload() {
    let filedata = this._service.getFileAttached();
    this.filesToUpload = [filedata];

    if (typeof this.filesToUpload[0] == 'undefined' || this.filesToUpload[0] == null) {
      Materialize.toast('SELECTED FILE FORMAT IS NOT VALID', 2000);
      return;
    }

    this.uploadingModel = true;
    let type = this.utilsService.determineModelType(this.filesToUpload[0].name);
    console.log('Detected filetype:', type);

    let modeldetails = {
      planid: 1
    };


    this.progressbarActive = true;

    this.uploadModelService.addModelWorkspace(this.filesToUpload, type, modeldetails)
    .subscribe(
      data => {
        console.log(data);
        console.log('addProject data:', data);
        let projectdata = JSON.parse(data);
        console.log('modeldata:', projectdata);
        let projectid = projectdata.projectid;
        console.log('Project ID:', projectid);

        let policy = projectdata.s3creds.s3Policy;
        let signature = projectdata.s3creds.s3Signature;
        let serverdate = projectdata.s3creds.serverDate;
        console.log('policy:', policy);
        console.log('signature:', signature);
        console.log('serverdate:', serverdate);

        this.uploadService.makeProjectUploadRequest(this.tenanturl, [], this.filesToUpload, this.tenantid, this.planid, true, projectid, policy, signature, serverdate).then((result) => {
          console.log('Uploaded file. Result:', result);

          if (type > 0) {
            this.uploadModelService.startProcessingUpload(projectid, this.tenantid, this.filesToUpload[0].name, this.planid)
            .subscribe(
              data => {
                this.progressbarActive = false;
                this.clearWorkspaceDropzone();
                Materialize.toast('MODEL UPLOADED SUCCESSFULLY.', 2000);
                this.modalworkspaceUploadAction.emit({ action: 'modal', params: ['close'] });
                console.log('startProcessingUpload completed');
                window.location.reload();
              },
              error => {
                this.errorMessage = <any>error;
                this.progressbarActive = false;
                this.clearWorkspaceDropzone();
                Materialize.toast('MODEL UPLOADED SUCCESSFULLY.', 2000);
                this.modalworkspaceUploadAction.emit({ action: 'modal', params: ['close'] });
                console.error('startProcessing error:', this.errorMessage);
              }
            );
          } else {
            // Just trigger the database to set the upload status to 2
            let updateProjectdetails = { upload_status: 2 };

            // Create the project to be able to get the project ID
            this.uploadModelService.updateProject(projectid, updateProjectdetails)
            .subscribe(
              data => {
                console.log('Project updated');
                this.progressbarActive = false;
                this.clearWorkspaceDropzone();
                Materialize.toast('MODEL UPLOADED SUCCESSFULLY.', 2000);
                this.modalworkspaceUploadAction.emit({ action: 'modal', params: ['close'] });
                console.log('startProcessingUpload completed');
                window.location.reload();
              },
              error => {
                this.errorMessage = <any>error;
                this.progressbarActive = false;
                this.clearWorkspaceDropzone();
                Materialize.toast('MODEL UPLOADED SUCCESSFULLY.', 2000);
                this.modalworkspaceUploadAction.emit({ action: 'modal', params: ['close'] });
                console.error('startProcessing error:', this.errorMessage);
              }
            );
          }
        },
        error => {
          this.errorMessage = <any>error;
          this.progressbarActive = false;
          this.clearWorkspaceDropzone();
          this.modalworkspaceUploadAction.emit({ action: 'modal', params: ['close'] });
          console.error('startProcessing error:', this.errorMessage);
        });
        this.uploadService.progress$.subscribe(
          data => {
            console.log('upload progress = ' + data);
            this.uploadCurrentValue = data;
          }
        );
      }
    );
  }

  openModalWorkspaceUpload(planid: string, tenantid: string, tenanturl: string) {
    this.planid = planid;
    this.tenantid = tenantid;
    this.tenanturl = tenanturl;

    this.modalworkspaceUploadAction.emit({ action: 'modal', params: ['open'] });
  }

 clearWorkspaceDropzone() {
    this.modalworkspaceUploadAction.emit({ action: 'modal', params: ['close'] });
    this.disableUploadButton = true;

    this._dropzoneWorkspace.clearWorkspaceDropzone();
  }

  disableWorkspaceUpload() {
    this.disableUploadButton = true;
  }

  clearDropzoneAttachments() {
    this._dropzoneattach.clearDropzoneAttach();
  }
  fileAdded() {
    this.disableUploadButton = false;
  }

  allowDrop(event, uploadTabOn, planid, tenantid, tenanturl) {
    console.log('Drag over called : event = ' + event + ' this.uploadTabOn : ' + uploadTabOn);
    console.log( 'planid:' + planid + '  tenantid: ' + tenantid + ' tenanturl" ' + tenanturl);
    if (!uploadTabOn) {
      this.openModalWorkspaceUpload(planid, tenantid, tenanturl);
    }
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/uploadmodel/uploadmodel.component.ts